// extracted by mini-css-extract-plugin
export default {"price":"m7-z","priceRow":"n7-z","onSale":"o7-z","msrpLabelPrice":"p7-z","msrpLabel":"q7-z","originalPrice":"r7-z","percentOff":"s7-z"};